export const CURRENT_YEAR = new Date().getFullYear();
export const DEFAULT_TARGET = "_blank";
export const DISCLOSURES_LINK = "https://www.wellsfargo.com/privacy-security/";
export const COPYRIGHT_FIRST_YEAR = "1999";